export const LOGO_URL = "/liveneat-logo.png";
export const LOGO_LIGHT_URL = "/liveneat-logo-light.png";
